import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { getRecentContents } from './models';

import {
  RecentContents as RecentContentsFeature,
  RecentContentsSkeleton,
} from '@/features/NewLanding';

const RecentContents = () => {
  const recentContentsPromise = getRecentContents();

  return (
    <ErrorBoundary fallback={<RecentContentsSkeleton />}>
      <Suspense fallback={<RecentContentsSkeleton />}>
        <RecentContentsFeature recentContentsPromise={recentContentsPromise} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default RecentContents;
